export default "__VITE_ASSET___an82WPJ__"